import React from "react";
import Aboutglovalreach from "../components/Aboutus/Aboutglovalreach";
import Banner from '../comman/Banner/Banner';


const Aboutglovalreachour = () => {
  return (
    <>
      <Banner
        index={'about-5'}
      />
      <Aboutglovalreach />
    </>

  )
};

export default Aboutglovalreachour;